(() => {
  const dialog = document.querySelector('[data-lt-cart-drawer]');
  if (!dialog || window.LittleTurtleCart) return;
  const sheet = dialog.querySelector('[data-cart-sheet]');
  const items = dialog.querySelector('[data-cart-items]');
  const status = dialog.querySelector('[data-cart-status]');
  const checkout = dialog.querySelector('[data-cart-checkout]');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let cart = null, busy = false, valid = false, request = 0, opener, animation, closing = false, locks = [];
  const root = () => window.Shopify?.routes?.root || '/';
  const money = value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cart?.currency || 'BRL' }).format(Number(value || 0) / 100);
  function lock() {
    // The document scrolls on mobile; locking its wrapper changes sticky positioning.
    const wrapper = matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
    locks = [document.documentElement, document.body, wrapper].filter(Boolean).map(element => ({ element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow') }));
    locks.forEach(({ element }) => element.style.setProperty('overflow', 'hidden'));
  }
  function unlock() {
    locks.forEach(({ element, value, priority }) => value ? element.style.setProperty('overflow', value, priority) : element.style.removeProperty('overflow'));
    locks = [];
  }
  function controls() {
    dialog.querySelector('[data-cart-body]').setAttribute('aria-busy', String(busy));
    dialog.querySelectorAll('[data-cart-quantity-step],[data-cart-quantity],[data-cart-remove],[data-cart-retry]').forEach(control => { control.disabled = busy; });
    checkout.disabled = busy || !valid || !cart?.item_count;
    dialog.querySelectorAll('.lt-cart-drawer__checkout-form a').forEach(link => {
      link.setAttribute('aria-disabled', String(checkout.disabled));
      link.style.pointerEvents = checkout.disabled ? 'none' : '';
    });
  }
  function showError(message) {
    const error = dialog.querySelector('[data-cart-error]');
    error.hidden = false;
    error.querySelector('[data-cart-error-text]').textContent = message;
  }
  function updateBadge() {
    document.querySelectorAll('.lt-cart').forEach(link => {
      let badge = link.querySelector('span');
      if (!cart.item_count) badge?.remove();
      else {
        if (!badge) { badge = document.createElement('span'); link.append(badge); }
        badge.textContent = String(cart.item_count);
      }
      link.setAttribute('aria-label', `Carrinho, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`);
    });
  }
  function safeProductUrl(value) {
    try { const url = new URL(value, location.origin); if (url.origin === location.origin) return url.href; } catch {}
    return dialog.dataset.productUrl;
  }
  function render(nextCart) {
    cart = nextCart; valid = true;
    dialog.querySelector('[data-cart-loading]').hidden = true;
    dialog.querySelector('[data-cart-error]').hidden = true;
    dialog.querySelector('[data-cart-empty]').hidden = Boolean(cart.item_count);
    dialog.querySelector('[data-cart-footer]').hidden = !cart.item_count;
    dialog.querySelector('[data-cart-count]').textContent = cart.item_count ? String(cart.item_count) : '';
    items.replaceChildren();
    cart.items.forEach(item => {
      const node = document.querySelector('#lt-cart-item-template').content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      node.dataset.variantId = String(item.variant_id);
      const title = node.querySelector('[data-cart-item-title]');
      title.textContent = item.product_title || item.title;
      title.href = safeProductUrl(item.url);
      const link = node.querySelector('[data-cart-item-link]');
      link.href = title.href;
      link.setAttribute('aria-label', `Ver ${title.textContent}`);
      const image = node.querySelector('[data-cart-item-image]');
      image.alt = `${title.textContent}${item.variant_title ? ' — ' + item.variant_title : ''}`;
      try {
        const source = item.featured_image?.url || item.image;
        if (!source) throw new Error('Missing image');
        const url = new URL(source, location.origin);
        if (!/^https?:$/.test(url.protocol)) throw new Error('Invalid image');
        url.searchParams.set('width', '200'); image.src = url.href;
      } catch { image.hidden = true; link.classList.add('has-no-image'); }
      image.addEventListener('error', () => { image.hidden = true; link.classList.add('has-no-image'); }, { once: true });
      node.querySelector('[data-cart-item-variant]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const properties = node.querySelector('[data-cart-item-properties]');
      Object.entries(item.properties || {}).forEach(([name, value]) => {
        if (name.startsWith('_') || !value) return;
        const property = document.createElement('li'); property.textContent = `${name}: ${value}`; properties.append(property);
      });
      properties.hidden = !properties.children.length;
      const discount = node.querySelector('[data-cart-item-discounts]');
      const labels = [...new Set((item.line_level_discount_allocations || []).map(value => value.discount_application?.title).filter(Boolean))];
      discount.textContent = labels.map(label => label === 'COMPRE2LEVE3' ? 'Compre 2, leve 3' : label).join(' · ');
      discount.hidden = !labels.length;
      const input = node.querySelector('[data-cart-quantity]');
      input.value = String(item.quantity);
      input.setAttribute('aria-label', `Quantidade de ${image.alt}`);
      node.querySelectorAll('[data-cart-quantity-step]').forEach(button => button.setAttribute('aria-label', `${Number(button.dataset.cartQuantityStep) < 0 ? 'Diminuir' : 'Aumentar'} quantidade de ${image.alt}`));
      node.querySelector('[data-cart-remove]').setAttribute('aria-label', `Remover ${image.alt}`);
      node.querySelector('[data-cart-item-price]').textContent = money(item.final_line_price);
      const original = node.querySelector('[data-cart-item-original]');
      original.textContent = money(item.original_line_price);
      original.hidden = item.original_line_price <= item.final_line_price;
      items.append(node);
    });
    dialog.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    const savings = dialog.querySelector('[data-cart-savings]');
    savings.hidden = !cart.total_discount;
    savings.textContent = cart.total_discount ? `Você economizou ${money(cart.total_discount)}` : '';
    updateBadge(); controls();
  }
  async function api(path, body) {
    const response = await fetch(root() + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    let data; try { data = await response.json(); } catch { throw new Error('Não foi possível atualizar seu carrinho. Tente novamente.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Não foi possível atualizar seu carrinho. Tente novamente.');
    return data;
  }
  async function refresh() {
    if (busy) return;
    const version = ++request;
    busy = true; valid = false; controls();
    dialog.querySelector('[data-cart-error]').hidden = true;
    try { const next = await api('cart.js'); if (version === request) render(next); }
    catch { if (version === request) { showError('Não foi possível carregar seu carrinho. Confira sua conexão e tente novamente.'); dialog.querySelector('[data-cart-loading]').hidden = true; } }
    finally { busy = false; controls(); }
  }
  async function change(node, quantity, action) {
    if (busy) return;
    const key = node.dataset.key, variant = node.dataset.variantId;
    const index = [...items.children].indexOf(node);
    const controlName = action?.hasAttribute('data-cart-remove') ? 'data-cart-remove' : action?.hasAttribute('data-cart-quantity-step') ? `data-cart-quantity-step="${action.dataset.cartQuantityStep}"` : 'data-cart-quantity';
    busy = true; ++request; controls(); status.textContent = '';
    try {
      const next = await api('cart/change.js', { id: key, quantity });
      render(next); status.textContent = quantity === 0 ? 'Produto removido do carrinho.' : 'Quantidade e subtotal atualizados.';
      if (dialog.open && !closing) {
        const target = [...items.children].find(item => item.dataset.key === key) || [...items.children].find(item => item.dataset.variantId === variant) || items.children[Math.min(index, items.children.length - 1)];
        // Controls are re-enabled before restoring keyboard focus.
        busy = false; controls();
        (target?.querySelector(`[${controlName}]`) || dialog.querySelector('[data-cart-close]')).focus({ preventScroll: true });
      }
    } catch (error) { valid = false; showError(error.message); if (cart) renderQuantity(node, key); }
    finally { busy = false; controls(); }
  }
  function renderQuantity(node, key) {
    const item = cart.items.find(item => item.key === key);
    if (item) node.querySelector('[data-cart-quantity]').value = String(item.quantity);
  }
  function animateSheet(frames, options) {
    sheet.style.willChange = 'transform';
    const current = sheet.animate(frames, { ...options, fill: 'both' });
    current.finished.catch(() => {}).finally(() => {
      if (animation === current && !closing) {
        sheet.style.transform = 'translate3d(0,0,0)';
        current.cancel(); animation = null; sheet.style.removeProperty('will-change');
      }
    });
    return current;
  }
  function close(immediate = false) {
    if (!dialog.open) return;
    const start = getComputedStyle(sheet).transform;
    animation?.cancel(); closing = true;
    function finish() {
      dialog.close(); animation?.cancel(); animation = null;
      sheet.style.removeProperty('transform'); sheet.style.removeProperty('will-change'); closing = false; unlock();
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    }
    if (immediate || reduce.matches) { finish(); return; }
    animation = animateSheet([{ transform: start }, { transform: 'translate3d(100%,0,0)' }], { duration: 240, easing: 'cubic-bezier(.4,0,1,1)' });
    animation.finished.then(finish).catch(() => {});
  }
  async function open({ cart: nextCart, opener: source } = {}) {
    if (source) opener = source; else if (!dialog.open) opener = document.activeElement;
    if (closing) {
      const from = getComputedStyle(sheet).transform;
      animation?.cancel(); closing = false;
      sheet.style.transform = reduce.matches ? 'translate3d(0,0,0)' : from;
      if (!reduce.matches) animation = animateSheet([{ transform: from }, { transform: 'translate3d(0,0,0)' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    // Populate confirmed cart data before the first visible animation frame.
    if (nextCart) { ++request; render(nextCart); }
    if (!dialog.open) {
      // Establish the off-screen position before promoting the dialog to the top layer.
      sheet.style.transform = reduce.matches ? 'translate3d(0,0,0)' : 'translate3d(100%,0,0)';
      lock(); dialog.showModal();
      // Autofocus must not horizontally scroll the overlay toward the off-screen sheet.
      dialog.querySelector('#lt-cart-title').focus({ preventScroll: true });
      dialog.scrollLeft = 0; dialog.scrollTop = 0;
      if (!reduce.matches) animation = animateSheet([{ transform: 'translate3d(100%,0,0)' }, { transform: 'translate3d(0,0,0)' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    if (!nextCart) await refresh();
  }
  window.LittleTurtleCart = { open, refresh };
  window.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (link && !link.hasAttribute('data-native-cart')) {
      const url = new URL(link.href, location.origin), cartUrl = new URL(dialog.dataset.cartUrl, location.origin);
      if (url.origin === cartUrl.origin && url.pathname === cartUrl.pathname) {
        event.preventDefault(); event.stopImmediatePropagation(); open({ opener: link }); return;
      }
    }
    if (dialog.contains(event.target) && event.target.closest('.lt-cart-drawer__checkout')) {
      if (busy || !valid || !cart?.item_count) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      // Leave checkout to the installed Luna integration; its overlay must not sit behind a modal top layer.
      close(true);
    }
  }, true);
  window.addEventListener('submit', event => {
    if (!event.target.matches('.lt-cart-drawer__checkout-form')) return;
    if (busy || !valid || !cart?.item_count) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    close(true);
  }, true);
  dialog.addEventListener('click', event => {
    if (event.target === dialog) { close(); return; }
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    if (event.target.closest('[data-cart-retry]')) { refresh(); return; }
    const node = event.target.closest('.lt-cart-drawer__item');
    if (!node) return;
    const button = event.target.closest('[data-cart-quantity-step],[data-cart-remove]');
    if (!button) return;
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, Math.min(99, Number(node.querySelector('[data-cart-quantity]').value) + Number(button.dataset.cartQuantityStep)));
    change(node, quantity, button);
  });
  dialog.addEventListener('change', event => {
    if (!event.target.matches('[data-cart-quantity]')) return;
    const input = event.target, node = input.closest('.lt-cart-drawer__item');
    if (!input.checkValidity()) { renderQuantity(node, node.dataset.key); input.reportValidity(); return; }
    change(node, Number(input.value), input);
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  reduce.addEventListener('change', () => { if (reduce.matches) animation?.finish(); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  document.addEventListener('cart:update', event => { if (!event.detail?.data?.errors) open(); });
})();
